import { isSetDate, MaybeDate, toDate } from "./Dates";

export const formatImproveStatusLabel = (status: string | null | undefined): string => {
  if (!status?.trim()) return "Not Started";

  switch (status.trim().toLowerCase().replace(/\s+/g, " ")) {
    case "partial":
      return "Partially Met";
    case "not_met":
      return "Not Met";
    case "in progress":
      return "In Progress";
    default:
      return status.replace(/_/g, " ");
  }
};

export type TaskWorkflowStatus = "Complete" | "Overdue" | "In Progress" | "Not Started";

/** Workflow status for task list badges; explicit taskStatus overrides comment-derived In Progress. */
export const getComputedTaskStatus = (
  task: {
    targetDate?: MaybeDate;
    completionDate?: MaybeDate;
    status?: string;
    taskStatus?: string;
  },
  options?: { hasComments?: boolean }
): string => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (isSetDate(task.completionDate)) {
    return "Complete";
  }

  if (isSetDate(task.targetDate)) {
    const target = toDate(task.targetDate!);
    const startOfTargetDay = new Date(
      target.getFullYear(),
      target.getMonth(),
      target.getDate()
    );

    if (startOfToday > startOfTargetDay) {
      return "Overdue";
    }
  }

  const explicitStatus = (task.status ?? task.taskStatus)?.trim();
  if (explicitStatus) {
    return explicitStatus;
  }

  if (options?.hasComments) {
    return "In Progress";
  }

  return "Not Started";
};

export const getTaskProgress = (task: {
    targetDate?: MaybeDate;
    completionDate?: MaybeDate;
    status?: string;
    taskStatus?: string;
  }) => {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    if (isSetDate(task.completionDate)) {
      return "Complete";
    }

    if (isSetDate(task.targetDate)) {
      const target = toDate(task.targetDate!);
      const startOfTargetDay = new Date(
        target.getFullYear(),
        target.getMonth(),
        target.getDate()
      );

      if (startOfToday > startOfTargetDay) {
        return "Overdue";
      }
    }

    const status = (task.status ?? task.taskStatus)?.trim();
    if (status) {
      return status;
    }

    return "Not Started";
  };